import React, { Component } from 'react'
import {QuantityStyle} from './../styles'
import {connect} from 'react-redux'

class Quantity extends Component {
  state = {
    qty: 0,
  }

  componentDidMount() {
    this.setState({ qty: this.props.qty })
  }

  moreQty = (e) => {
    e.preventDefault()
    this.setState({ qty: this.state.qty + 1}, () => {
      this.callBack()
    })
  }

  lessQty = (e) => {
    e.preventDefault()
    this.setState({ qty: this.state.qty > 0 ? this.state.qty - 1 : 0}, () => {
      this.callBack()
    })
  }

  callBack = () => {
    this.props.updateQty(this.state.qty, this.props.id)
  }

  render () {
    const { qty } = this.state
    return (
      <div className={`flex ${QuantityStyle}`}>
        <span className="qty-less" onClick={this.lessQty}></span>
        <span className="qty-number">
          { qty }
        </span>
        <span className="qty-more" onClick={this.moreQty}></span>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    role: Session.role
  })
)(Quantity)


// WEBPACK FOOTER //
// ./src/components/Quantity.js